import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-nanny-dark text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">Nanny's</h3>
            <p className="text-gray-300 text-sm mb-4">
              Homemade meals and catering services in Huntingdon, TN since 2021.
            </p>
            <p className="text-sm italic text-nanny-cream">
              From Our Kitchen To Yours
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-nanny-cream transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-nanny-cream transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/menu" className="text-gray-300 hover:text-nanny-cream transition-colors text-sm">
                  Menu
                </Link>
              </li>
              <li>
                <Link to="/catering" className="text-gray-300 hover:text-nanny-cream transition-colors text-sm">
                  Catering Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-nanny-cream transition-colors text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-nanny-cream transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-nanny-cream mt-0.5 flex-shrink-0" />
                <div>
                  <a href="tel:731-267-9884" className="text-gray-300 hover:text-nanny-cream transition-colors text-sm">
                    731-267-9884
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-nanny-cream mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300 text-sm">18725 W Main St</p>
                  <p className="text-gray-300 text-sm">Huntingdon, TN 38344</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Facebook className="h-5 w-5 text-nanny-cream mt-0.5 flex-shrink-0" />
                <div>
                  <a 
                    href="https://www.facebook.com/profile.php?id=100068874377725" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-nanny-cream transition-colors text-sm"
                  >
                    Follow us on Facebook
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Hours</h4>
            <div className="space-y-3">
              <div>
                <div className="flex items-start space-x-3 mb-2">
                  <Clock className="h-5 w-5 text-nanny-cream mt-0.5 flex-shrink-0" />
                  <p className="text-gray-300 font-semibold text-sm">In-Store</p>
                </div>
                <p className="text-gray-400 text-sm ml-8">Monday - Thursday</p>
                <p className="text-gray-300 text-sm ml-8">10:30 AM - 5:30 PM</p>
              </div>
              <div>
                <p className="text-gray-300 font-semibold text-sm ml-8">Catering</p>
                <p className="text-gray-300 text-sm ml-8">7 Days a Week</p>
                <p className="text-gray-400 text-xs ml-8">Breakfast, Lunch & Supper</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Nanny's. All rights reserved. | Est. 2021
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
